import * as _ from 'lodash';
import { Packable } from "./packable";

export class UncategorizedArrival extends Packable {
    validationKey = "arrival";
    constructor(data: any){
        super(data);
    }
}
